import { useMemo } from 'react';

import {
  createTheme,
  responsiveFontSizes,
  StyledEngineProvider,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';

import shape from './shape';
import { palette } from './palette';
import { shadows } from './shadows';
import { typography } from './typography';
import { customShadows } from './custom-shadows';

import GlobalStyles from './globalStyles';
import componentsOverride from './overrides';

import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import { faIR } from '@mui/material/locale';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMomentJalaali } from '@mui/x-date-pickers/AdapterMomentJalaali';
import 'moment/locale/fa';

// ----------------------------------------------------------------------

export default function MUIThemeProvider({ children }) {
  const {
    mode,
    color,
    language: { direction },
  } = useSelector((state) => state.setting);

  const themeOptions = useMemo(
    () => ({
      shape,
      direction,
      typography,
      shadows: shadows(mode),
      palette: palette(mode, color),
      customShadows: customShadows(),
    }),
    [direction, mode, color]
  );

  let theme = createTheme(themeOptions, faIR);
  theme = responsiveFontSizes(theme);
  theme.components = componentsOverride(theme);

  return (
    <div dir={direction}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMomentJalaali} adapterLocale="fa">
            <CssBaseline />
            <GlobalStyles />
            {children}
          </LocalizationProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}
